import Button from './button'

export default Button



// WEBPACK FOOTER //
// ./client/components/button/index.tsx